var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37836e-06 90.58V295.58C-0.00131202 300.346 0.936016 305.065 2.75855 309.468C4.58108 313.872 7.25316 317.873 10.6221 321.244C13.991 324.615 17.9907 327.289 22.3931 329.114C26.7955 330.939 31.5144 331.879 36.28 331.88H228.79C233.557 331.881 238.278 330.943 242.683 329.119C247.088 327.296 251.09 324.622 254.461 321.251C257.832 317.88 260.506 313.878 262.329 309.473C264.153 305.068 265.091 300.347 265.09 295.58V36.8899C265.091 32.1225 264.153 27.4017 262.329 22.997C260.506 18.5922 257.832 14.59 254.461 11.219C251.09 7.84797 247.088 5.17412 242.683 3.35034C238.278 1.52656 233.557 0.588531 228.79 0.589845H90.01L18.8398 71.7399L1.37836e-06 90.58Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.58L18.8398 71.7399L90.01 0.589845H228.79C233.557 0.588531 238.278 1.52656 242.683 3.35034C247.088 5.17412 251.09 7.84797 254.461 11.219C257.832 14.59 260.506 18.5922 262.329 22.997C264.153 27.4017 265.091 32.1225 265.09 36.8899V121.25H0V90.58Z",
    fill: "#4F87C2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.5798L44.4299 100.39C53.8584 102.336 63.6739 100.458 71.7173 95.1675C79.7607 89.8771 85.3731 81.6082 87.3198 72.1798L89.1799 61.9897C88.5906 64.8004 87.6568 67.5276 86.3999 70.1097C83.4265 76.2457 78.785 81.4201 73.0071 85.0404C67.2291 88.6607 60.5484 90.5805 53.73 90.5798H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90.58H53.6899C60.5084 90.5806 67.1891 88.6608 72.967 85.0405C78.745 81.4202 83.3864 76.2458 86.3599 70.1099C88.7277 65.1681 89.9612 59.7597 89.97 54.2799V0.589844L18.8 71.7399L0 90.58Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.541 175.52H53.5703V186.66H114.541V175.52Z",
    fill: "#4F87C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.541 206.78H53.5703V217.92H114.541V206.78Z",
    fill: "#4F87C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.541 238.03H53.5703V249.17H114.541V238.03Z",
    fill: "#4F87C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.541 269.28H53.5703V280.42H114.541V269.28Z",
    fill: "#4F87C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.962 269.28H144.992V280.42H205.962V269.28Z",
    fill: "#4F87C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.522 247.63H139.422V175.52H211.522V247.63ZM150.522 236.49H200.352V186.66H150.522V236.49Z",
    fill: "#4F87C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.d3a8a4e268632f20c1fcc33695599ebb.svg";
export { ForwardRef as ReactComponent };